import trackfocus from "../../../../assets/images/docs/debugtools/track-focus.mp4";
import * as React from 'react';
export default {
  trackfocus,
  React
};